import {Box} from "@mui/material"
import React from "react"
import ContainerTableRow from "./ContainerTable/ContainerTableRow"
import Content from "../../components/Content"

export const containerTablePrototype = [
    "gridconfiguration",
    {
        "key": "rowGap",
        "type": "INTEGER",
        "label": "Abstand Zeilen (in px)",
        "size": 3,
    },
]

const ARRAYOFFSET = 1

const ContainerTable = ({container, value}) => {
    const rows = value ?? []
    const headerWidgets = container.children?.filter((entry) => entry.y === 0)
    const contentWidgets = container.children?.filter(
        (entry) => entry.y === 1,
    )
    const additionalWidgets = container.children?.filter(
        (entry) => entry.y > 1,
    )

    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: `repeat(${container?.columncount}, 1fr)`,
                alignItems: "center",
                rowGap: (container?.rowGap || 0) + "px"
            }}>
            {headerWidgets?.map((widget) => (
                <Box
                    key={widget.id}
                    height="100%"
                    sx={{
                        gridColumn: widget.x + 1 + " /span " + widget.w,
                        gridRow: widget.y + 1 + " /span " + widget.h,
                    }}>
                    <Content child={widget} />
                </Box>
            ))}
            {rows?.length ? (
                rows.map((row, key) =>
                    contentWidgets?.map((widget) => (
                        <ContainerTableRow
                            key={widget.id + key}
                            row={row}
                            widget={widget}
                            rowCount={key}
                        />
                    )),
                )
            ) : (
                <Box
                    padding={2}
                    sx={{
                        gridColumn: 1 + " /span " + container?.columncount,
                        gridRow: 2
                    }}>
                    Keine Einträge
                </Box>
            )}
            {additionalWidgets?.map((widget) => (
                <Box
                    key={widget.id}
                    sx={{
                        gridColumn:
                            widget.x + ARRAYOFFSET + " /span " + widget.w,
                        gridRow:
                            widget.y +
                            ARRAYOFFSET +
                            (rows?.length ? rows?.length : 1 ) +
                            " /span " +
                            widget.h,
                    }}>
                    <Content
                        key={widget.i}
                        child={widget}
                    />
                </Box>
            ))}
        </Box>
    )
}

export default ContainerTable
